import styled from 'styled-components'

export const ButtonComponentWrapper = styled.div<{ isHidden?: boolean }>`
  opacity: ${o => (o.isHidden ? 0 : 1)};
  transition-duration: 0.7s;
  width: 100%;
`

export const AddToBagButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
`
